import styled from "styled-components";

interface OwnProps {
	title: string;
}
export const RootNodeTitle = ({ title }: OwnProps) => {
	return <Title>{title}</Title>;
};

const Title = styled.p`
	word-break: break-word;
	hyphens: auto;
	text-align: center;
	font-size: 19px;
	font-style: normal;
	font-weight: 600;
	line-height: 24px;
	letter-spacing: 1.2px;
	margin-bottom: 24px;
`;
